<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Vip1`]" width="1em" height="1em" v-bind="$attrs"><path d="M18.9049 23H5.08977C3.29142 23 1.77222 21.6646 1.55749 19.8929L0.0087577 7.08658C-0.0449244 6.64764 0.151015 6.21669 0.518738 5.96397C0.88646 5.71391 1.36423 5.6873 1.75879 5.89214L6.49356 8.36082L10.9948 1.53736C11.2176 1.20218 11.5934 1 11.9987 1C12.404 1 12.7824 1.20218 13.0025 1.53736L17.5064 8.36348L22.2412 5.8948C22.6358 5.68996 23.1135 5.71657 23.4813 5.96663C23.849 6.21669 24.0449 6.6503 23.9912 7.08924L22.4398 19.8955C22.2224 21.6646 20.7059 23 18.9049 23ZM2.66334 9.05248L3.94097 19.6109C4.01076 20.1882 4.50464 20.6218 5.09245 20.6218H18.9075C19.4927 20.6218 19.9866 20.1882 20.059 19.6109L21.3367 9.05248L17.6594 10.9705C17.1146 11.2551 16.4355 11.0822 16.0973 10.5688L11.9987 4.36252L7.90271 10.5715C7.56452 11.0849 6.88812 11.2578 6.34056 10.9732L2.66334 9.05248Z" :fill="useCurrentColor ? 'currentColor' : '#fff'"/><path d="M12 18C11.3604 18 10.7207 17.7881 10.221 17.3667L7.39696 14.9689C6.88583 14.5348 6.86584 13.8121 7.35127 13.355C7.83671 12.8979 8.64481 12.88 9.15594 13.3141L11.98 15.712L14.8441 13.3141C15.3552 12.88 16.1633 12.8979 16.6487 13.355C17.1342 13.8121 17.1142 14.5348 16.603 14.9689L13.779 17.3667C13.2793 17.7881 12.6396 18 12 18Z" :fill="useCurrentColor ? 'currentColor' : '#fff'"/></svg>
</template>
<script>

export default {
  name: 'IconVip1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
